import React from "react";
import { PageWrapper } from "../PageWrapper";
import { Route, Routes } from "react-router-dom";
import { SettingsOverview } from "./SettingsOverview";
import { ProtectedRoute } from "../../components/ProtectedRoute/ProtectedRoute";

export const SettingsPage: React.FC = () => {
  return (
    <PageWrapper>
      <Routes>
        <Route
          path={"/*"}
          key={"/"}
          element={<ProtectedRoute childRouteElement={<SettingsOverview />} />}
        />
      </Routes>
    </PageWrapper>
  );
};
